<template>
  <div class="coupon-wrap">
    <div class="rule" v-if="lists.length > 0">
      <span @click="verify_show = true"
        ><i class="elementIcon iconwenhao"></i>规则说明</span
      >
    </div>
    <div class="coupon-list" v-if="lists.length > 0">
      <div
        class="coupon-item"
        :class="{
          active: checked && item.id === couponId,
          grey: (checked && activeName === '2') || (btn && activeIndex === 4)
        }"
        v-for="(item, index) in lists"
        :key="index"
      >
        <div class="coupon">
          <div class="money">
            <price :price="item.coupon_template.discount_value" />
            <div
              class="text"
              v-if="item.coupon_template.min_purchase_amount == 0"
            >
              无门槛
            </div>
            <div class="text" v-else>
              满{{ item.coupon_template.min_purchase_amount | jifen2 }}可用
            </div>
          </div>
          <div class="coupon-detail">
            <div class="title">{{ item.coupon_template.template_name }}</div>
            <div class="cell">适用商城：{{ activityName }}</div>
            <div class="cell">
              适用品类：{{ item.coupon_template.description }}
            </div>
            <c-date
              :start_date="item.start_date"
              :end_date="item.end_date"
              :activeIndex="activeIndex"
            />
          </div>
          <div class="coupon-right">
            <div
              class="btn-use"
              v-if="btn && activeIndex === 1"
              :class="{ 'grey-bg': item.disabled }"
              @click="goHome(item)"
            >
              {{ item.text }}
            </div>
            <el-checkbox
              :value="item.id === couponId"
              @change="changeCoupon(item)"
              v-if="checked && activeName === '1'"
            ></el-checkbox>
            <div class="info">
              <el-popover placement="bottom" width="400" trigger="click">
                <div class="coupon-info">
                  <div class="cell">
                    1、适用商城：{{ activityName }}<br />
                    2、有效期至：{{ item.end_date }}；<br />
                    3、适用于：{{ item.applicable_category }}；<br />
                    4、规则说明：限{{ item.start_date }}至{{
                      item.end_date
                    }}期间使用。
                  </div>
                </div>
                <span slot="reference">
                  <i class="elementIcon icontishi"></i>详情信息</span
                >
              </el-popover>
            </div>
          </div>
        </div>
      </div>
    </div>
    <is-empty v-else></is-empty>
    <el-dialog
      title="规则说明"
      :visible.sync="verify_show"
      width="600px"
      append-to-body
    >
      <div slot="footer">
        <el-button type="primary" @click="verify_show = false">关闭</el-button>
      </div>
      <div class="verify_text">{{ verify_text }}</div>
    </el-dialog>
  </div>
</template>
<script>
import price from "./price";
import cDate from "./c_date";
import IsEmpty from "@/components/is-empty";
export default {
  components: {
    price,
    cDate,
    IsEmpty
  },
  props: {
    btn: Boolean,
    activeIndex: Number,
    lists: {
      type: Array,
      default: () => []
    },
    checked: Boolean,
    couponId: Number,
    activeName: String
  },
  data() {
    return {
      show: false,
      coupon: {
        coupon_template: {}
      },
      verify_show: false,
      verify_text: `1、优惠券在指定商城可用，可购买指定平台商品，具体可用范围请至优惠券页面查看；
        2、优惠券有期限限制，过期将会失效作废，不支持延期，请及时使用；
        3、每次提交订单时，仅可选用1张优惠券，满减类型优惠券不可抵扣运费；
        4、订单发生部分退款时，优惠券不退还：下单时若使用了优惠券，系统会将优惠券实际优惠金额，分摊至订单中每个商品中，即每个商品价格包含实际支付价格+优惠券优惠金额。若发生部分退款，将只退还分摊后商品实际支付的金额；
        5、订单整单退款，且优惠券未过期，将会退还优惠券，退还的优惠券有效期不变；如优惠券已过期，则不会退还优惠券；
        6、优惠券的规则最终解释权归上班族所有。`,
      activityName: ""
    };
  },
  mounted() {
    this.activityName = sessionStorage.getItem("activityName");
  },
  methods: {
    goHome(coupon) {
      if (coupon.disabled) {
        return;
      }
      this.$router.push({ path: "/" });
    },
    changeCoupon(coupon) {
      this.$emit("changeCoupon", coupon);
    }
  }
};
</script>
<style scoped lang="less">
.coupon-wrap {
  .rule {
    text-align: right;
    padding: 10px 30px;
    color: #999999;
    > span {
      cursor: pointer;
    }
  }
  .coupon-list {
    display: flex;
    flex-wrap: wrap;
    padding: 0 10px;
    .coupon-item {
      margin: 10px 1%;
      width: 48%;
      position: relative;
      background-color: #f9f9f9;
      box-sizing: border-box;
      border-radius: 8px;
      overflow: hidden;
      box-sizing: border-box;
      .coupon {
        height: 100px;
        display: flex;
        position: relative;
        .money {
          width: 90px;
          height: 100%;
          background: linear-gradient(to left top, #fcda9a, #fdf1d6);
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          .price {
            color: #ff482c;
            font-weight: bold;
            .price-unit {
              font-size: 16px;
            }
            .price-coupon {
              font-size: 32px;
              line-height: 28px;
            }
          }
          .text {
            width: 100%;
            text-align: center;
            font-size: 12px;
            color: #666666;
          }
        }
        .coupon-detail {
          margin-left: 12px;
          padding-top: 12px;
          flex: 1;
          font-size: 12px;
          color: #999;
          overflow: hidden;
          .title {
            font-size: 15px;
            color: #000;
            font-weight: bold;
          }
          .date {
            color: #ff482c;
            margin-top: 4px;
          }
        }
        .coupon-right {
          position: relative;
          width: 80px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          .btn-use {
            width: 56px;
            height: 22px;
            line-height: 22px;
            border-radius: 11px;
            text-align: center;
            color: #fff;
            font-size: 12px;
            white-space: nowrap;
            border: none;
            background-image: linear-gradient(to right, #ff7660, #ff4700);
            cursor: pointer;
          }
          .grey-bg {
            background-image: none;
            background-color: #cccccc;
          }
          .info {
            color: #999;
            font-size: 12px;
            position: absolute;
            bottom: 12px;
            cursor: pointer;
            .el-icon-arrow-right {
              font-size: 12px;
              transform: rotate(90deg);
            }
            .delete {
              transform: rotate(-90deg);
            }
          }
        }
      }
      .coupon-info {
        color: #999;
        font-size: 10px;
        padding: 12px;
      }
    }
    > .active {
      background-color: #fdebec;
      border: 1px solid #e2333f;
      box-sizing: border-box;
    }
    > .grey {
      .coupon {
        .money {
          background: #eeeeee;
          .price {
            color: #999;
            font-weight: bold;
          }
          .text {
            color: #999;
          }
        }
        .coupon-detail {
          .title {
            color: #999;
          }
          .date {
            color: #999;
            margin-top: 4px;
          }
        }
        .coupon-right {
          .btn-use {
            background-image: none;
            background-color: #cccccc;
          }
          .info {
            color: #999;
          }
        }
      }
      .coupon-info {
        color: #999;
        font-size: 10px;
        padding: 12px;
      }
    }
  }
}
.cell {
  width: 100%;
  line-height: 22px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/deep/ .el-checkbox__inner {
  width: 20px;
  height: 20px;
  line-height: 20px;
  border-radius: 0;
  &::after {
    height: 12px;
    left: 7px;
  }
  &:hover {
    border-color: #e2333f;
  }
}
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
/deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #e2333f;
  border-color: #e2333f;
}
/deep/ .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #e2333f;
}
.verify_text {
  white-space: pre-line;
}
/deep/ .el-dialog__body {
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/coupon-list/index.vue